<template>
  <div id="modal-weight-info" class="modal modal_callback" style="display: none;">
    <div class="modal__inner weightInfo">
      <div class="left">
        <div class="picture">
          <img :src="data ? data.detailImg : ''">
        </div>
      </div>
      <div class="right">
        <div class="title">
          Серия {{ data ? data.serieName : '' }}
        </div>
        <p class="text">
          Нагрузка {{ data ? data.text : '' }}
        </p>  
        <div class="detailText">
          {{ data ? data.detailText : '' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	props: {
		data: {
			type: Object,
			default: {},
		},
	},
});
</script>
<style lang="scss" scoped>
  #modal-weight-info {
    width: 750px;
    padding: 40px;
    border-bottom: 0 none;
  }
  .weightInfo {
    display: flex;
    gap: 32px;
  }
  .picture {
    width: 271px;
    height: 260px;
    border: 1px solid #bebebe;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .title {
    font-size: 24px;
    font-weight: bold;
    margin: 0 0 16px 0;
  }
  .text {
    font-size: 16px;
    font-weight: bold;
    margin: 0 0 16px 0;
  }
  .detailText {
    font-size: 16px;
    margin: 0 0 16px 0;
  }
</style>
